import {
  BENEFITS_SURVEY_REQUEST,
  BENEFITS_SURVEY_SUCCESS,
  BENEFITS_SURVEY_FAILURE,
  SAVE_BENEFITS_SURVEY_SUCCESS,
  DISABLE_SURVEY_REDIRECTION,
} from "actions/benefitsSurveyActions";

const initialState = {
  surveyData: {},
  redirectAfterSubmit: false,
  isFetching: false,
  isFetched: false,
  error: null,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case BENEFITS_SURVEY_REQUEST:
      return { ...state, fetching: true };
    case BENEFITS_SURVEY_SUCCESS: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        surveyData: action.payload,
        redirectAfterSubmit: false,
      };
    }
    case BENEFITS_SURVEY_FAILURE:
      return { ...state, fetching: false, error: action.payload };

    case SAVE_BENEFITS_SURVEY_SUCCESS:
      return {
        ...state,
        redirectAfterSubmit: action.payload.redirectAfterSubmit,
      };

    case DISABLE_SURVEY_REDIRECTION:
      return {
        ...state,
        redirectAfterSubmit: false,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/benefitsSurveyReducer.js